var _mask, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgSingle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 95,
    viewBox: "0 0 96 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 96,
    height: 95
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 47.9097,
    cy: 47.6001,
    r: 47.25,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 47.9097,
    cy: 47.6001,
    r: 47.25,
    fill: "#D6E8F6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-9.54882 67.9781L-1.77313 67.236C-1.14969 67.1764 -0.559991 67.5305 -0.319341 68.1089L5.55116 82.2329C5.91956 83.1195 5.32468 84.109 4.3686 84.2005L-3.72217 84.9729C-4.35663 85.0331 -4.95421 84.6665 -5.18676 84.0739L-10.7422 69.9194C-11.0883 69.0371 -10.4932 68.0687 -9.54882 67.9781Z",
    fill: "#233862"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-1.78595 93.1947C-1.9227 93.3125 -8.45914 86.6338 -11.9495 82.9334L-8.4533 80.8062L10.6363 92.7844L-1.78595 93.1947Z",
    fill: "#FFB27D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.2277 14.5067C51.3514 13.9227 52.9078 7.67089 62.6147 9.01832C62.6147 9.01832 57.7725 8.75846 56.5895 10.7005C56.5895 10.7005 60.269 8.68652 62.7542 9.97281C65.2416 11.2589 65.9838 16.1347 65.7364 17.6528C65.4868 19.1706 63.1747 23.8012 61.434 23.9259C60.7727 23.9734 60.053 23.8045 59.4098 23.5768C59.7337 24.3472 60.0373 25.1879 60.3049 26.1146C62.7789 34.6831 57.4644 41.7123 54.3539 40.2925C52.359 39.3818 51.1468 42.8444 51.1468 42.8444L33.6992 22.8786C33.6992 22.8786 43.8441 8.74924 51.2277 14.5067Z",
    fill: "#2C3A64"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.3732 68.0473C35.6497 69.6256 38.5037 70.9272 42.0865 71.7535C55.5156 74.8548 60.6615 63.51 62.5957 55.7226C60.7627 54.6751 59.0399 54.4442 58.0458 54.3255C57.0742 54.2111 56.0532 54.1351 55.2075 54.0933C53.7006 52.9387 51.4538 48.2137 50.9568 40.8779L50.3248 41.0472L39.7407 43.9426C39.7407 43.9426 40.2243 47.3053 40.4627 50.4839C40.6471 52.9709 40.6763 55.3479 40.204 55.9294C39.3786 56.1084 38.8816 56.2255 38.8816 56.2255C38.8816 56.2255 38.8816 56.2291 38.8771 56.2354C38.7354 56.4683 35.6632 61.5154 33.3732 68.0473Z",
    fill: "#D7AE88"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.7407 43.9438C39.7407 43.9438 40.2265 47.3038 40.4627 50.4851C46.4587 49.8849 49.2407 44.1789 50.3248 41.0488L39.7407 43.9438Z",
    fill: "#BF9976"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.9494 47.1012C37.9494 47.1012 52.1814 46.3165 51.5562 37.4649C50.931 28.6135 52.3456 22.5507 43.2324 22.6777C34.1183 22.8045 32.5935 26.3066 32.0832 29.3117C31.5731 32.3173 34.2299 47.0776 37.9494 47.1012Z",
    fill: "#D7AE88"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.1537 24.3612C34.1599 21.5414 35.8631 22.0062 36.8504 22.74C44.3151 17.9134 49.7735 23.8671 49.7735 23.8671C51.1815 30.1495 56.0237 33.459 56.0237 33.459C56.0237 33.459 53.5475 35.2443 47.4638 34.1374C45.606 33.7991 43.8832 32.6198 42.3854 31.1472C45.0932 35.024 48.5928 37.7058 48.5928 37.7058C41.2226 34.921 37.6444 25.2076 37.2845 24.1789C36.4726 25.0203 34.8825 26.8351 34.4806 28.531C33.9339 30.8356 33.9478 35.4983 32.5837 35.4372C32.5837 35.4372 29.1447 28.5899 32.1537 24.3612Z",
    fill: "#2C3A64"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.6448 55.5138C35.6448 55.5138 58.8326 49.8874 68.9129 58.1983L60.9706 93.3139L63.875 128.432L18.5292 117.482C18.5292 117.482 19.8051 113.038 28.5004 101.22C37.1966 89.4026 33.4135 72.0683 35.6448 55.5138Z",
    fill: "#D7AE88"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.0378 78.2302C70.92 86.6794 66.4421 97.0187 64.843 102.584C64.843 102.584 67.5149 121.906 64.9623 127.211C64.6744 127.817 64.3145 128.24 63.8737 128.43C54.4186 132.547 17.5965 128.549 16.0422 116.677C15.4773 112.364 30.0678 97.1891 30.918 95.3483C31.2713 94.5867 31.6467 92.1179 29.9365 87.0016C27.5115 94.4736 23.0334 103.102 18.5286 104.573C13.5784 106.192 -5.99567 91.613 -5.99567 91.613C-5.99567 91.613 -6.10857 89.8421 -3.63415 88.1671C-2.04294 87.0899 1.61178 86.7269 1.61178 86.7269L14.1285 92.3252C15.6992 89.6389 19.6128 71.0536 23.9821 62.6642C27.2673 56.3575 36.0393 55.4439 36.0393 55.4439C36.0393 55.4439 39.6895 61.2315 48.5194 60.4106C57.3469 59.5899 58.9618 54.188 58.9618 54.188C58.9618 54.188 66.793 55.2283 69.204 57.174C69.6223 57.5114 73.5064 67.1606 72.0378 78.2302Z",
    fill: "#3D83BB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.8439 102.584C64.8439 102.584 67.5158 121.906 64.9631 127.211C58.0742 123.755 49.096 116.295 51.8286 104.638C55.7982 87.7031 72.0386 78.23 72.0386 78.23C70.9209 86.6792 66.443 97.0185 64.8439 102.584Z",
    fill: "#1E5D8F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.9631 54.188C58.9631 54.188 70.3369 55.5365 73.4675 60.4106C77.4259 66.5736 86.6259 81.7506 86.3246 87.9358C86.3246 87.9358 85.9404 91.009 63.6599 110.216C63.6599 110.216 57.5798 108.832 62.5075 105.991C62.5075 105.991 76.0517 86.7024 77.4371 85.4822L68.099 75.5644L58.9631 54.188Z",
    fill: "#3D83BB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-11.2412 68.1313L-3.46529 67.3888C-2.84185 67.3294 -2.25192 67.6835 -2.01172 68.2619L3.85901 82.3861C4.2274 83.2722 3.63275 84.2623 2.67668 84.3533L-5.41432 85.1259C-6.04878 85.1864 -6.64636 84.8195 -6.87914 84.2265L-12.4341 70.0726C-12.7805 69.1899 -12.1851 68.2212 -11.2412 68.1313Z",
    fill: "#2B478B"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgSingle);
export default __webpack_public_path__ + "static/media/imgSingle.f1a197fc9d861858c58842d2c3732b41.svg";
export { ForwardRef as ReactComponent };